<template>
  <div class="row">
    <div
        class="col-sm-12 col-md-4 col-lg-3 col-xl-3 mb-primary"
        v-if="data.length > 0"
        v-for="(response, rowIndex) in data"
        :key="'row' + rowIndex"
    >
      <ResponseGridCard
          ref="componentUpdate"
          :id="id"
          :data="response"
          :actions="actions"
          @action-grid-view-table="getAction"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: "ResponseGrid",
  props: ["id", "data", "actions"],
  data(){
    return{
      open : false,
    }
  },
  created(){
  },

  methods: {
    getAction(row, action, active) {
      this.$emit("getCardAction", row, action, active);
    },
  },

  watch: {
    data: function (oldVal , newVal) {
      this.$hub.$emit("reload-" + this.data);
    }
  }
};
</script>
<style>

.cardNewStyle {
  border: 0.5px solid #898989 !important;
}

</style>
